import {createServerFn} from '@tanstack/react-start';
import {eq} from 'drizzle-orm';
import {db} from './db.server';
import {page as pageTable} from './db/schema';
import {imageIDsFromMarkdown} from '../utils/markdownText';
import {directusImages} from './directusImage.server';
import {markdownText, pageColumns} from './markdownText.server';

export const pageLoader = createServerFn()
  .validator((slug: string) => slug)
  .handler(async ({data: slug}) => {
    const data = await db.query.page.findFirst({
      where: eq(pageTable.slug, slug),
      columns: pageColumns,
    });

    if (!data) {
      return null;
    }

    const {left, right, bottom, content, ...page} = data;
    const imageMap = await directusImages(
      imageIDsFromMarkdown(left, right, bottom, content),
    );

    const [contentMd, leftMd, rightMd, bottomMd] = await Promise.all([
      content ? markdownText(content, imageMap) : undefined,
      left ? markdownText(left, imageMap) : undefined,
      right ? markdownText(right, imageMap) : undefined,
      bottom ? markdownText(bottom, imageMap) : undefined,
    ]);

    return {
      ...page,
      left: leftMd,
      right: rightMd,
      bottom: bottomMd,
      content: contentMd,
    };
  });
